import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=1691c6be&scoped=true&"
import script from "./privacy.js?vue&type=script&lang=js&"
export * from "./privacy.js?vue&type=script&lang=js&"
import style0 from "./privacy.scss?vue&type=style&index=0&id=1691c6be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1691c6be",
  null
  
)

export default component.exports